export default __webpack_public_path__ + "static/media/bariol_thin_italic-webfont.48040a12.woff";